import { stripCustPrefix } from '../../../utils/CommonFunctions';
import { CustomerApiData, CustomerData } from './TypeCustomer';

export function formatTableData(data: CustomerApiData[]) {
  const res:CustomerData[] = [];

  data.forEach((col:CustomerApiData) => {
    const obj = {
      select: '',
      action: 'edit&delete',
      markUp: '',
      custId: '',
      customerName: '',
      address: '',
      cityName: '',
      stateName: '',
      phone: '',
      smc: '',
      id: '',
    };

    obj.markUp = col.Markup;
    obj.custId = stripCustPrefix(col.Custid);
    obj.customerName = col.Customername;
    obj.address = col.Address;
    obj.cityName = col.CityName;
    obj.stateName = col.StateName;
    obj.phone = col.Phone;
    obj.smc = col.SmcName;
    obj.id = col.Custid;

    res.push(obj);
  });

  return res;
}
